<template>
  <div class="theme-information">
    <!-- 热门咨询 左12个 右4个 -->
    <div class="info-container" v-show="Object.keys(hotArticle).length !== 0">
      <div class="info-wrapper">
        <div class="info-bar clearfix">
          <span class="info-title">热门资讯</span>
          <!-- <a class="info-more" href="javascript:;">more</a> -->
        </div>

        <div class="info-hot clearfix">
          <div class="info-hot-left">
            <ul class="info-hot-list">
              <li
                v-for="(article, index) in hotArticle.leftArticles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: article.id } }"
                  >{{ article.title }}</router-link
                >
              </li>
              <li
                v-if="
                  hotArticle.leftArticles &&
                    hotArticle.leftArticles.length >= 12
                "
              >
                <router-link
                  class="fr"
                  :to="{
                    name: 'NewsList',
                    params: {
                      id: hotArticle.leftCatogoryId
                        ? hotArticle.leftCatogoryId
                        : 0,
                    },
                  }"
                  >更多</router-link
                >
              </li>
            </ul>
          </div>
          <div class="info-hot-right">
            <div class="info-hot-banner">
              <img :src="concatImageUrl(hotArticle.image, 560, 300)" />
            </div>
            <ul class="info-hot-list">
              <li
                v-for="(article, index) in hotArticle.rightArticles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: article.id } }"
                  >• {{ article.title }}</router-link
                >
              </li>
              <li
                v-if="
                  hotArticle.rightArticles &&
                    hotArticle.rightArticles.length >= 4
                "
              >
                <router-link
                  class="fr"
                  :to="{
                    name: 'NewsList',
                    params: {
                      id: hotArticle.rightCatogoryId
                        ? hotArticle.rightCatogoryId
                        : 0,
                    },
                  }"
                  >更多</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻公告 7个 -->
    <div class="info-container" v-show="Object.keys(newsList).length !== 0">
      <div class="info-wrapper">
        <div class="info-bar clearfix">
          <span class="info-title">新闻公告</span>
          <router-link
            class="info-more"
            :to="{
              name: 'NewsList',
              params: { id: newsList.categoryId ? newsList.categoryId : 0 },
            }"
            >more</router-link
          >
        </div>
        <div class="info-message clearfix">
          <div class="info-message-left">
            <div class="info-message-banner">
              <img :src="concatImageUrl(newsList.image, 560, 320)" />
            </div>
          </div>
          <div class="info-message-right">
            <ul class="info-message-list">
              <li v-for="(article, index) in newsList.articles" :key="index">
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: article.id } }"
                >
                  <span>•</span>
                  {{ article.title }}
                </router-link>
                <p v-show="index === 0">{{ article.summary }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 热门课程 8 个 -->
    <div class="info-container" v-show="hotProductList.length > 0">
      <div class="info-wrapper">
        <div class="info-bar clearfix">
          <span class="info-title">热门课程</span>
        </div>

        <ul class="info-hot-product clearfix">
          <li v-for="(product, index) in hotProductList" :key="index">
            <router-link
              :to="{
                name: product.type === 1 ? 'MajorDetail' : 'CourseDetail',
                params: { id: product.productId },
              }"
            >
              <div class="can-integral" v-if="product.isIntegral"></div>
              <div class="hot-product-img">
                <img v-lazy="concatImageUrl(product.image, 260, 130)" />
                <div class="can-live" v-if="product.hasLive"></div>
              </div>
              <h3 class="hot-product-title">{{ product.name }}</h3>
              <span class="hot-product-type"
                >【{{ product.specialName }}】</span
              >
              <span class="hot-product-price">
                <span
                  v-show="
                    formatPrice(product.discountPrice, product.price)[0] !==
                      '-1'
                  "
                  >￥{{
                    formatPrice(product.discountPrice, product.price)[0]
                  }}</span
                >
                <s
                  v-show="
                    formatPrice(product.discountPrice, product.price)[1] !==
                      '-1'
                  "
                  style="
                    margin-left: 8px;
                    color: #808080;
                    font-weight: normal;
                    font-size: 12px;
                  "
                  >￥{{
                    formatPrice(product.discountPrice, product.price)[1]
                  }}</s
                >
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 商品类型列表 商品6个 文章11个 -->
    <div
      class="info-container"
      v-for="(item, index) in productCategoryList"
      :key="index"
    >
      <div class="info-wrapper">
        <div class="info-bar clearfix">
          <span class="info-title">
            <img :src="getIconUrl(index)" />
            {{ item.dmTypeName }}
          </span>
          <router-link
            class="info-more"
            :to="{ name: 'ProductList', query: { c: item.dmTypeId } }"
            >more</router-link
          >
        </div>
        <ul class="info-product-label clearfix">
          <li v-for="(label, labelIndex) in item.dmLables" :key="labelIndex">
            <span>{{ label.lableName }}</span>
            <ul>
              <li
                v-for="(major, majorIndex) in label.majorList"
                :key="majorIndex"
              >
                <a
                  href="javascript:;"
                  @click="getProductList(item, major.MajorID)"
                  >{{ major.MajorName }}</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <div class="info-product-body clearfix">
          <div class="info-product-left">
            <ul class="clearfix">
              <li
                v-for="(product, productIndex) in item.productList"
                :key="productIndex"
              >
                <div class="product-item">
                  <div class="can-integral" v-if="product.isIntegral"></div>
                  <div class="can-live" v-if="product.hasLive"></div>
                  <span class="product-special">{{ product.specialName }}</span>
                  <h3 class="product-title">{{ product.name }}</h3>
                  <span class="product-type">{{ item.dmTypeName }}</span>
                  <div class="product-teacher">
                    <router-link
                      :to="{
                        name: 'TeacherDetail',
                        params: {
                          id: teacher.teacherId ? teacher.teacherId : 0,
                        },
                      }"
                      v-for="(teacher, teacherIndex) in product.teachers"
                      :key="teacherIndex"
                    >
                      <span
                        :style="
                          'background-image: url(' +
                            concatImageUrl(teacher.pic1, 50, 50) +
                            ');'
                        "
                      ></span>
                      <p>{{ teacher.tchName }}</p>
                    </router-link>
                  </div>
                  <router-link
                    class="product-link"
                    :to="{
                      name: product.type === 1 ? 'MajorDetail' : 'CourseDetail',
                      params: { id: product.productId },
                    }"
                    >免费试听</router-link
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="info-product-right">
            <!-- 右侧双新闻 -->
            <div
              class="news-fun"
              v-for="(article, articleIndex) in item.articles1"
              :key="articleIndex"
            >
              <div class="news-fun-icon">
                <img :src="'/img/art-icon-' + (articleIndex + 1) + '.png'" />
              </div>
              <div class="news-fun-text">
                <p>{{ article.title }}</p>
                <p>{{ article.summary }}</p>
              </div>
              <router-link
                class="news-fun-btn"
                :to="{ name: 'NewsDetail', params: { id: article.id } }"
                >详情 ></router-link
              >
            </div>

            <!-- 右侧Tab新闻切换 -->
            <ul class="news-cate">
              <li
                :class="{ selected: !item.active || item.active === 'a' }"
                @click="changeNewsTab(item, 'a')"
              >
                <span>{{ item.articles2.title }}</span>
              </li>
              <li
                :class="{ selected: item.active && item.active === 'b' }"
                @click="changeNewsTab(item, 'b')"
              >
                <span>{{ item.articles3.title3 }}</span>
              </li>
            </ul>
            <div class="news-body">
              <ul
                class="news-list"
                v-show="!item.active || item.active === 'a'"
              >
                <li
                  v-for="(article, articleIndex) in item.articles2.article2List"
                  :key="articleIndex"
                >
                  <router-link
                    :to="{ name: 'NewsDetail', params: { id: article.id } }"
                    >{{ article.title }}</router-link
                  >
                </li>
                <li
                  v-show="
                    item.articles2.article2List &&
                      item.articles2.article2List.length >= 11
                  "
                >
                  <router-link
                    clase="fr"
                    :to="{
                      name: 'NewsList',
                      params: { id: item.articles3.id ? item.articles3.id : 0 },
                    }"
                    >更多</router-link
                  >
                </li>
              </ul>
              <ul class="news-list" v-show="item.active && item.active === 'b'">
                <li
                  v-for="(article, articleIndex) in item.articles3.article3List"
                  :key="articleIndex"
                >
                  <router-link
                    :to="{ name: 'NewsDetail', params: { id: article.id } }"
                    >{{ article.title }}</router-link
                  >
                </li>
                <li
                  v-show="
                    item.articles3.article3List &&
                      item.articles3.article3List.length >= 11
                  "
                >
                  <router-link
                    clase="fr"
                    :to="{
                      name: 'NewsList',
                      params: { id: item.articles3.id ? item.articles3.id : 0 },
                    }"
                    >更多</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 名师推荐 -->
    <div class="info-container" v-show="teacherList && teacherList.length > 0">
      <div class="info-wrapper">
        <div class="info-bar clearfix">
          <span class="info-title">
            <img src="../../assets/images/theme/title-icon-3.png" /> 师资团队
          </span>
          <router-link :to="{ name: 'TeacherList' }" class="info-more"
            >more</router-link
          >
        </div>
        <div class="info-teacher clearfix">
          <router-link
            v-for="(item, index) in teacherList"
            :key="index"
            :to="{ name: 'TeacherDetail', params: { id: item.teacherId } }"
            class="info-teacher-item"
          >
            <div
              class="teacher-avatar"
              :style="
                'background-image: url(' +
                  concatImageUrl(item.pic1, 200, 265) +
                  ');'
              "
            ></div>
            <div class="teacher-name">{{ item.tchName }}</div>
            <div class="teacher-remark">{{ item.academy }}</div>
          </router-link>
        </div>
      </div>
    </div>

    <friend-link v-show="siteConfig.agencyId != 0"></friend-link>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { home } from "../../request";
import FriendLink from "./FriendLink";
export default {
  mixins: [siteMixin],
  data() {
    return {
      hotArticle: {},
      newsList: {},
      hotProductList: [],
      productCategoryList: [],
      teacherList: [],
    };
  },
  mounted() {
    this.getProductData();
  },
  methods: {
    getProductData() {
      home.getThemeData(this.siteConfig.agencyId).then((result) => {
        if (result.status === 1) {
          if (result.data.information) {
            this.hotArticle = result.data.information.consultationSectionList;
            this.newsList = result.data.information.newsSectionList;
            this.hotProductList = result.data.information.hotRecommendedList;
            this.productCategoryList =
              result.data.information.productCategoryList;
            this.teacherList =
              result.data.information.recommendedByFamousTeachers;
          } else {
            this.$Message.error("数据异常2");
          }
          //console.log(result);
        }
      });
    },
    getIconUrl(index) {
      return `/img/title-icon-${index}.png`;
    },
    getProductList(item, m) {
      //console.log(item, m);
      home.getProductList(this.siteConfig.agencyId, m).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          item.productList = res.data;
        }
      });
    },
    changeNewsTab(item, tab) {
      if (typeof item.active === "undefined") {
        this.$set(item, "active", tab);
      } else {
        item.active = tab;
      }
    },
  },
  components: {
    FriendLink,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
// .theme-information {
//   // padding-top: 15px;
// }
.info-container {
  width: 100%;
  .theme-information > &:nth-child(even) {
    background-color: #fff5e7;
  }
  .theme-information > &:nth-child(odd) {
    background-color: #fff;
  }
  .can-integral {
    .can-integral();
    left: 0;
    top: 0;
  }
  .can-live {
    .can-live();
    left: -1px;
    bottom: 0;
  }
}
.info-wrapper {
  width: 1200px;
  margin: 0 auto;
  .info-bar {
    padding: 20px 30px;
    border-bottom: 1px solid #ccc;

    .info-title {
      font-size: 2.6rem;
      font-weight: bold;
      letter-spacing: 0.2rem;
      img {
        .inline-block();
      }
    }

    .info-more {
      font-size: 1.8rem;
      float: right;
      margin-top: 15px;
    }
  }
}

.info-hot {
  padding-bottom: 30px;
  .info-hot-left {
    float: left;
    width: 580px;

    .info-hot-list {
      width: 100%;

      li {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 30px;
        line-height: 30px;

        &:nth-child(3n + 1) {
          margin-top: 20px;

          a {
            font-size: 1.8rem;
            color: #ff6600;
          }
        }
      }
    }
  }

  .info-hot-right {
    float: left;
    width: 580px;
    margin-left: 40px;

    .info-hot-banner {
      width: 560px;
      height: 300px;
      margin: 25px 10px 10px 10px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .info-hot-list {
      width: 560px;
      margin: 0 auto;

      li {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}

.info-message {
  padding-bottom: 40px;

  .info-message-left {
    float: left;
    width: 580px;

    .info-message-banner {
      width: 560px;
      height: 320px;
      margin: 25px 10px 10px 10px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .info-message-right {
    float: left;
    width: 580px;
    margin-left: 40px;

    .info-message-list {
      width: 560px;
      margin: 0 auto;
      padding-top: 30px;

      li {
        a {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          height: 35px;
          line-height: 35px;
          font-size: 1.6rem;

          span {
            font-size: 2.6rem;
            vertical-align: middle;
            margin-right: 10px;
          }
        }

        p {
          padding-left: 30px;
          padding-bottom: 15px;
          text-indent: 2em;
          color: #999;
        }
      }
    }
  }
}

.info-hot-product {
  li {
    float: left;
    width: 260px;
    height: 200px;
    margin: 30px 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    position: relative;

    .hot-product-img {
      position: relative;
      width: 100%;
      height: 130px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .hot-product-title {
      padding: 0 5px;
      height: 40px;
      line-height: 40px;
      color: #333;
      .ellipsis();
    }

    .hot-product-type {
      color: #999;
    }

    .hot-product-price {
      float: right;
      color: #ff6600;
      margin-right: 10px;
      margin-top: 2px;
      font-weight: bold;
    }
  }
}

.info-product-label {
  padding: 10px;

  & > li {
    float: left;
    position: relative;
    padding: 5px 0;
    width: 100px;
    margin: 0 5px;
    text-align: center;
    border-bottom: 3px solid transparent;

    & > span {
      display: block;
      font-size: 1.6rem;
      font-weight: bold;
      max-width: 100px;
      height: 21px;
      overflow: hidden;
    }

    & > ul {
      display: none;
      position: absolute;
      top: 34px;
      left: -65px;
      width: 230px;
      box-shadow: 1px 1px 5px #ccc;
      border-radius: 10px;
      background-color: #fff;
      padding: 15px 0;
      z-index: 10;

      li {
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 1.4rem;

        &:hover {
          background-color: #f5f5f5;

          a {
            color: #ff6600;
          }
        }
      }
    }

    &:hover {
      border-color: #ff6600;

      & > ul {
        display: block;
      }
    }
  }
}

.info-product-body {
  padding-bottom: 20px;

  .info-product-left {
    float: left;
    width: 900px;

    li {
      float: left;
      width: 280px;
      height: 340px;
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
    }

    .product-item {
      background-color: #fff;
      box-shadow: 1px 1px 5px #ccc;
      overflow: hidden;
      border-radius: 10px;
      padding: 25px 20px;
      position: relative;

      &:hover {
        margin-top: -5px;
      }
    }

    .product-special {
      display: inline-block;
      padding: 5px 10px;
      border: 1px solid #ccc;
      min-width: 80px;
      border-radius: 30px;
      text-align: center;
    }

    .product-title {
      padding: 15px 0;
      font-size: 1.8rem;
      width: 100%;
      .ellipsis();
    }

    .product-type {
      color: #999;
    }

    .product-teacher {
      padding: 25px 0;
      border-bottom: 1px solid #ccc;
      height: 130px;
      a {
        display: inline-block;
        text-align: center;
        margin-right: 20px;

        span {
          display: block;
          width: 50px;
          height: 50px;
          border-radius: 50px;
          overflow: hidden;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
        }

        p {
          color: #333;
          font-size: 1.6rem;
          margin-top: 5px;
        }
      }
    }

    .product-link {
      display: block;
      margin: 20px auto 0 auto;
      width: 190px;
      height: 36px;
      line-height: 36px;
      background-color: #ff6600;
      border-radius: 50px;
      text-align: center;
      color: #fff;
      font-size: 1.8rem;
    }
  }

  .info-product-right {
    float: left;
    width: 300px;
    padding: 15px 10px;
    background-color: #fff;
    box-shadow: 1px 1px 5px #ccc;
    border-radius: 10px;
    height: 706px;
    overflow: hidden;

    .news-fun {
      border-bottom: 1px dashed #ccc;
      padding: 20px 10px;

      & > div {
        display: inline-block;
        vertical-align: middle;
      }

      .news-fun-icon {
        margin-right: 10px;
        width: 32px;
        overflow: hidden;
      }

      .news-fun-text {
        width: 120px;
        height: 45px;
        overflow: hidden;

        p {
          .ellipsis();

          &:first-child {
            font-size: 1.8rem;
          }

          &:last-child {
            color: #999;
            font-size: 1.5rem;
          }
        }
      }

      .news-fun-btn {
        width: 90px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ff6600;
        color: #ff6600;
        font-size: 1.6rem;
        border-radius: 30px;
        text-align: center;
        display: inline-block;
      }
    }

    .news-cate {
      margin-top: 20px;
      border-bottom: 1px solid #ccc;
      height: 45px;

      li {
        display: inline-block;
        padding: 0 10px;
        margin-right: 10px;
        max-width: 45%;
        span {
          display: block;
          width: 100%;
          font-size: 1.8rem;
          padding: 5px 5px 8px 5px;
          color: #666;
          border-bottom: 5px solid transparent;
          margin-bottom: -3px;
          cursor: pointer;
          .ellipsis();
        }

        &:hover {
          span {
            color: #333;
          }
        }

        &.selected {
          span {
            color: #333;
            border-bottom: 5px solid #ff6600;
          }
        }
      }
    }

    .news-body {
      margin-top: 15px;

      .news-list {
        li {
          font-size: 1.6rem;
          height: 35px;
          line-height: 35px;
          width: 100%;
          .ellipsis();

          span {
            display: inline-block;
            border: 1px solid #ccc;
            color: #ff6600;
            line-height: 1;
            padding: 3px 5px 2px 7px;
            border-radius: 6px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.info-teacher {
  padding: 30px 0;

  .info-teacher-item {
    float: left;
    width: 260px;
    height: 380px;
    padding: 25px 12px;
    margin: 0 20px 20px 20px;
    border: 1px solid #ccc;
    border: 1px solid #ffffff;
    display: block;
    background-color: #fff;
    box-shadow: 0 0 8px #ccc;
    border-radius: 10px;
    overflow: hidden;

    &:hover {
      background-color: #f8f8f8;
    }

    .teacher-avatar {
      width: 200px;
      height: 265px;
      background-color: #fff;
      text-align: center;
      margin: 0 auto;
      border-radius: 50% 50%;
      overflow: hidden;
      border: 1px solid #eee;
      box-shadow: 0 0 3px #eee;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .teacher-name {
      line-height: 25px;
      font-size: 1.8rem;
      text-align: center;
      padding-top: 20px;
      color: #333;
    }

    .teacher-remark {
      text-align: center;
      color: #999;
    }
  }
}
</style>
